/* Hamak i Ja — blog "Więcej artykułów" (sections/main-blog.liquid, <hk-blog-list>).
   Fetches the next page through the Section Rendering API and appends its article cards;
   without JS the button is a normal pagination link. */
(() => {
  if (customElements.get('hk-blog-list')) return;

  class HkBlogList extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('a[data-hk-blog-load]');
        if (!btn || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        this.loadMore(btn);
      });
    }

    async loadMore(btn) {
      if (btn.classList.contains('is-loading')) return;
      const href = btn.getAttribute('href');
      const label = btn.textContent;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      if (btn.dataset.loadingText) btn.textContent = btn.dataset.loadingText;
      try {
        const url = new URL(href, window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const res = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const grid = this.querySelector('[data-hk-blog-grid]');
        const items = [...doc.querySelectorAll('[data-hk-blog-grid] > li:not(.hk-bmain__item--news)')];
        items.forEach((li) => grid.appendChild(document.adoptNode(li)));
        const more = this.querySelector('[data-hk-blog-more]');
        const nextMore = doc.querySelector('[data-hk-blog-more]');
        if (more && nextMore) more.replaceWith(document.adoptNode(nextMore));
        items[0]?.querySelector('a[href]')?.focus({ preventScroll: true });
      } catch (err) {
        console.error('[hk-blog-list]', err);
        window.location.href = href;
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
      }
    }
  }

  customElements.define('hk-blog-list', HkBlogList);
})();
